export enum ShowStyles {
  Kiosk = 'kiosk',
  None = 'none',
  Main = 'main',
  MainFullBleed = 'main-full-bleed',
  MainTightHeader = 'main-tight-header',
  NoHeaders = 'no-headers',
}
